import React, { Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { generateKey } from './helper/uniqueKey';
import { getProductsAction } from './store/asyncActions/getProductsAction';
import { useDispatch } from 'react-redux';
import { Spinners } from './components/Spinners';
import { useAppSelector } from './store';
import ErrorPage from './pages/ErrorPage';
import routes from './routes';
import { getOrderInfoAction } from './store/asyncActions/getOrderInfoAction';
import { hotjarScript } from './constants/hotjar';

const Layout = React.lazy(() => import('./layout'));
const GetStarted = React.lazy(() => import('./pages/GetStarted'));
const OrderInfo = React.lazy(() => import('./pages/OrderInfo'));
const WaitingListPage = React.lazy(() => import('./pages/WaitingList'));
const GotItPage = React.lazy(() => import('./pages/GotIt'));
const Congrats = React.lazy(() => import('./pages/Congrats'));
const PaymentError = React.lazy(() => import('./pages/PaymentError'));

function App() {
  const dispatch = useDispatch();
  const { isFirstVisited } = useAppSelector((state) => state.settingsReducer);
  const { isFetching, orderInfo } = useAppSelector(
    (state) => state.orderInfoReducer
  );

  useEffect(() => {
    dispatch(getProductsAction());
    dispatch(getOrderInfoAction());

    if (process.env.REACT_APP_AGWA_ENV === 'prod') {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = hotjarScript;
      document.head.appendChild(script);
    }
  }, [dispatch]);

  return (
    <BrowserRouter>
      <Suspense fallback={<Spinners.ABSOLUTE height={100} />}>
        <Routes>
          {isFetching ? (
            <Route path='*' element={<Spinners.ABSOLUTE height={100} />} />
          ) : orderInfo.available ? (
            <Route path='/' element={<Layout />}>
              {!isFirstVisited ? (
                <>
                  <Route path='home' element={<GetStarted />} />
                  <Route path='congrats' element={<Congrats />} />
                  <Route path='canceled' element={<PaymentError />} />
                  <Route path='*' element={<Navigate to='/home' />} />
                </>
              ) : (
                <>
                  {routes.map((route) => (
                    <Route
                      key={generateKey()}
                      path={route.path}
                      element={route.element}
                    />
                  ))}
                  <Route path='order-info' element={<OrderInfo />} />
                  <Route path='error' element={<ErrorPage />} />
                  <Route path='*' element={<Navigate to='/error' />} />
                </>
              )}
              <Route path='/' element={<Navigate to='/home' replace />} />
            </Route>
          ) : (
            <>
              <Route path='/waiting-list' element={<WaitingListPage />} />
              <Route path='/got-it' element={<GotItPage />} />
              <Route path='congrats' element={<Congrats />} />
              <Route path='canceled' element={<PaymentError />} />
              <Route path='/error' element={<ErrorPage />} />
              <Route
                path='*'
                element={<Navigate replace to='/waiting-list' />}
              />
              <Route
                path='/'
                element={<Navigate replace to='/waiting-list' />}
              />
            </>
          )}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
